import { Box, useTheme } from "@mui/material"
import { PageCard, PageCardContent } from "components/card"
import { EmptyData } from "components/EmptyData"
import { ServiceIcon } from "components/icons"
import { MotionDiv } from "components/motions"
import { VenueSelector } from "components/VenueSelector"
import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"
import { ServiceCard } from "extensions/iconsiam/components/domains/service/card/index.kiosk-v"
import { IframeModal } from "extensions/iconsiam/components/modal"
import { SidebarMenu } from "extensions/iconsiam/components/navigation/kiosk-h/SidebarMenu"
import { useServiceLocation } from "extensions/iconsiam/hooks/service"
import { useService } from "hooks/service"
import { useTranslation } from "providers/i18n"
import { usePageSideBarLayout } from "providers/ui/hooks"
import { useVenue } from "providers/venue"
import { useMemo } from "react"
import { getIcon } from "utils/icon"

export const ServicesKioskHPage = ({
  Layout = Box,
  AppNavigation = DefaultAppNavigation,
}) => {
  const { t } = useTranslation({ defaultValue: null })
  const {
    evenColServices,
    oddColServices,
    hasData,
    locationVenueId,
    venueFilter,
    changeVenueFilter,
  } = useService()
  const { externalUrl, handleClickLocation, handleCloseModal } =
    useServiceLocation()
  const isTransportationIframe =
    externalUrl && externalUrl.includes("transportation-dashboard")
  const { venues, isMultiVenueProject } = useVenue()
  const theme = useTheme()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.service) || <ServiceIcon />,
    [theme]
  )

  const { styleOverrides = {} } = theme.components?.[`ServicePage`] || {}
  const {
    gridContainer,
    gridItem,
    emptyDataContainer,
    venueSelector,
    pageCard,
    pageCardContent,
    contentWrapper,
  } = styleOverrides

  usePageSideBarLayout({
    sidebar: {
      open: false,
    },
  })

  return (
    //@ts-ignore
    <Layout
      aside={
        <PageCard>
          <SidebarMenu AppNavigation={AppNavigation} />
        </PageCard>
      }
    >
      <PageCard sx={pageCard}>
        <PageCardContent sx={pageCardContent}>
          <MotionDiv
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            sx={contentWrapper}
          >
            <>
              {hasData ? (
                <Box sx={gridContainer}>
                  <Box sx={gridItem}>
                    {evenColServices.map((service, index) => (
                      <ServiceCard
                        onClickLocation={handleClickLocation}
                        key={`service-even-item-${index}`}
                        data={service}
                      />
                    ))}
                  </Box>
                  <Box sx={gridItem}>
                    {oddColServices.map((service, index) => {
                      return (
                        <ServiceCard
                          onClickLocation={handleClickLocation}
                          key={`service-odd-item-${index}`}
                          data={service}
                        />
                      )
                    })}
                  </Box>
                </Box>
              ) : (
                <Box sx={emptyDataContainer}>
                  <EmptyData
                    icon={emptyIcon}
                    primary={t("No Services")}
                    secondary={t("Check Back Soon")}
                  />
                </Box>
              )}
            </>
            {isMultiVenueProject && (
              <Box sx={venueSelector}>
                <VenueSelector
                  selectedVenue={venueFilter}
                  venues={venues}
                  onClickVenue={changeVenueFilter}
                  currentVenue={locationVenueId}
                />
              </Box>
            )}
          </MotionDiv>
        </PageCardContent>
      </PageCard>
      <IframeModal
        src={externalUrl}
        className={
          isTransportationIframe ? "IframeModal-transportation-iframe" : ""
        }
        open={!!externalUrl}
        onClose={handleCloseModal}
      />
    </Layout>
  )
}
